import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations';
import type { HomeRedesignStrings } from '../../locales/homeRedesign';

export function useHomeRedesignStrings(): HomeRedesignStrings {
  const { currentLanguage } = useLanguage();
  const pack = translations[currentLanguage as 'en' | 'es'].homeRedesign as HomeRedesignStrings | undefined;
  if (!pack) {
    return translations.en.homeRedesign as HomeRedesignStrings;
  }
  return pack;
}
